module.exports = __webpack_public_path__ + "media/images/aapoc-a97f79c34015f06090dfc1745547905a.png";